import { Component, OnInit, Input } from '@angular/core';
import { CommonAuthenticationService, CommonRequestResponseService, NotificationService } from 'app/services';

@Component({
  selector: 'app-chat-archive-parent',
  templateUrl: './chat-archive-parent.component.html',
  styleUrls: ['./chat-archive-parent.component.scss']
})
export class ChatArchiveParentComponent implements OnInit {
  @Input() dynamicParentUserId: number;
  messages: any[];
  isLoading = false;
  studentName: string;
  chatData: any;
  show: number;

  constructor(
    private notificationService: NotificationService,
    private _commonAuthService: CommonAuthenticationService,
    private _commonRequestResponseService: CommonRequestResponseService,
  ) { }

  ngOnInit() {
    const localStorageData = this._commonAuthService.getLoginData();
    this.studentName = localStorageData.firstName + ' ' + localStorageData.lastName;
    this.getMessages();
  }

  getMessages() {
    this.isLoading = true;
    const inputJson = {
      studentUserId: this.dynamicParentUserId,

    };
    this._commonRequestResponseService.post('student/GetChatArchive', inputJson)
      .subscribe(
        (communicationDataJson: any) => {
          this.isLoading = false;
          this.messages = communicationDataJson.chatData;
        },
        () => {
          this.isLoading = false;
          this.messages = [];
          this.notificationService.show('error', 'Error while calling service');
        });
  }

  showCommunicationThread(item: any, index: number) {
    this.show = index;
    this.chatData = item;
  }

}
